import { ref as storageRef, getDownloadURL, deleteObject } from 'firebase/storage';
import { useEffect, useState } from 'react';
import { storage } from '@config/firebase/client';

const getText = async (url: string): Promise<string> => {
    const response = await fetch(url);

    if (!response.ok) {
        const { status } = response;
        let body = null;
        try {
            body = await response.json();
        } catch (e) {
            // No body
        }

        throw new Error(`${status} - ${body}`);
    }

    return response.text();
};

const useFullText = (
    id: string,
    collectionName: string,
    retryOnFail = false,
    refetchOnChange = false,
    removeAfterFetch = false,
): [string | undefined, boolean, string | undefined] => {
    const [fullText, setFullText] = useState<string>();
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState<string>();

    useEffect(() => {
        setIsLoading(true);
        const fetchFullText = async () => {
            const storageDocumentRef = storageRef(storageRef(storage, collectionName), id);
            const url = await getDownloadURL(storageDocumentRef);
            const text = await getText(url);
            setFullText(text);
            if (removeAfterFetch) {
                deleteObject(storageDocumentRef);
            }
        };
        const getFullText = async () => {
            if (!id) return;
            try {
                try {
                    await fetchFullText();
                } catch (e) {
                    if (retryOnFail) {
                        await fetchFullText();
                    } else {
                        throw e;
                    }
                }
            } catch (e) {
                setError(JSON.stringify(e));
            } finally {
                setIsLoading(false);
            }
        };
        getFullText();
    }, [collectionName, id, refetchOnChange, removeAfterFetch, retryOnFail]);

    return [fullText, isLoading, error];
};

export default useFullText;
